<template>
  <div style="min-height: 100vh; background: linear-gradient(to right, #030e27 0%, #527592 100%); padding: 2rem">
    <slot />
  </div>
</template>

<script setup>
//...
</script>
